import React from 'react'
import './unique.css'
export default function Unique() {
    return (
        <div className='unique-container'>
            <div className="unique-header">
                <h3>Features That Set Us Apart</h3>
            </div>
            <div className="unique-box">
                <div className="text-one">
                    <div className="unique-text-container">
                        <div className="icon">
                            <i className="bx bx-transfer"></i>
                        </div>
                        <div className="unique-container-text">
                            <h4>Instant Transfers & Payments</h4>
                            <p>Transfer money instantly and make payments effortlessly, without the hidden fees. Say goodbye to delays and high charges.</p>
                        </div>
                    </div>
                </div>
                <div className="text-one">
                    <div className="unique-text-container">
                        <div className="icon">
                            <i class='bx bxs-bank'></i>
                        </div>
                        <div className="unique-container-text">
                            <h4>Automated Savings & Goals</h4>
                            <p>Set savings goals and let FinFlex do the rest. Our automated system helps you save small amounts regularly without even noticing.</p>
                        </div>
                    </div>
                </div>
                <div className="text-one">
                    <div className="unique-text-container">
                        <div className="icon">
                            <i className="bx bx-shield-quarter"></i>
                        </div>
                        <div className="unique-container-text">
                            <h4>Advanced Security Protocols</h4>
                            <p>Your security is our priority. FinFlex uses 256-bit encryption, biometric authentication, and real-time fraud alerts to keep your money safe.</p>
                        </div>
                    </div>
                </div>
                <div className="text-one">
                    <div className="unique-text-container">
                        <div className="icon">
                            <i className="bx bx-slider-alt"></i>
                        </div>
                        <div className="unique-container-text">
                            <h4>Personalized Budgeting</h4>
                            <p>Create custom budgets that match your lifestyle. Receive notifications to help you stay on track and make adjustments when needed.</p>
                        </div>
                    </div>
                </div>
                <div className="text-one">
                    <div className="unique-text-container">
                        <div className="icon">
                            <i className="bx bx-globe"></i>
                        </div>
                        <div className="unique-container-text">
                            <h4>Currency Management</h4>
                            <p>Manage multiple currencies effortlessly. Whether you’re traveling or investing, FinFlex supports easy currency exchanges at the best rates.</p>
                        </div>
                    </div>
                </div>
                <div className="text-one">
                    <div className="unique-text-container">
                        <div className="icon">
                            <i className="bx bx-gift"></i>
                        </div>
                        <div className="unique-container-text">
                            <h4>Rewards & Cashback Offers</h4>
                            <p>Earn rewards and cashback on everyday purchases. FinFlex partners with top brands to bring you exclusive deals that help you save more.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
